import { createContext, useContext } from 'react';
import { Device } from '../../models/Devices';

type DevicesContextType = {
    devices: Device[];
    device: Device;
    setDevices: (value: Device[]) => void;
    setDevice: (value: Device) => void;
    resetDevice: () => void;
};

export const DevicesContext = createContext({} as DevicesContextType);

export const useDevicesContext = () => {
    const context = useContext(DevicesContext);

    if (!context) throw new Error('useDevicesContext must be used within a DevicesProvider');

    return context;
};
